import {useEffect, useRef, useState} from 'react'
import {cn} from 'src/layouts/main-layout/app-sidebar/utils/utils'

export function CompaniesSelectorScrollText({text, className, onClick}: {text: string; className?: string; onClick?: () => void}) {
  const containerRef = useRef<HTMLDivElement>(null)
  const textRef = useRef<HTMLSpanElement>(null)

  const [hasOverflow, setHasOverflow] = useState(false)

  useEffect(() => {
    const checkOverflow = () => {
      if (!containerRef.current || !textRef.current) return

      const containerWidth = containerRef.current.clientWidth
      const textWidth = textRef.current.scrollWidth

      setHasOverflow(textWidth > containerWidth)
    }

    checkOverflow()

    window.addEventListener('resize', checkOverflow)
    return () => window.removeEventListener('resize', checkOverflow)
  }, [text])

  return (
    <div ref={containerRef} className='group relative flex min-w-0 flex-1 items-center overflow-hidden' data-slot='scroll-text-div' onClick={onClick}>
      <span ref={textRef} data-slot='span-text' className={cn('whitespace-nowrap cursor-pointer', hasOverflow && 'group-hover:animate-scroll-text', className)}>
        {text}
      </span>
    </div>
  )
}
